var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"total-box"},[_c('p',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.$t('CLOSING_REASONS.TABLE.TOTAL_RESOLVED_CONVERSATIONS'))+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"number"},[_vm._v(_vm._s(_vm.total))])])}
var staticRenderFns = []

export { render, staticRenderFns }